import React, { useEffect, useState } from 'react'
import { getBudgetsUser, getCartsUser } from '../hooks/gets'
import './UserBudgets.scss'
import * as _ from 'lodash'
import UserBudgetsBlock from './UserBudgetBlock'

const UserBudgets = ({ userData }) => {
    const [budgetsFinish, setBudgetsFinish] = useState([])
    const [budgetsSave, setBudgetsSave] = useState([])
    const [budgetsScheurichFinish, setBudgetsScheurichFinish] = useState([])
    const [budgetsScheurichSave, setBudgetsScheurichSave] = useState([])

    useEffect(() => {
        getBudgetsUser(userData.id).then(res => {
            let productsRemove = [];
            let budgets = []
            for (let i = 0; i < res.data.length; i++) {
                const budget = res.data[i];
                const productsArray = JSON.parse(budget.products)
                productsRemove = _.remove(productsArray, product => {
                    return product.product.Nombre.toLowerCase().indexOf('expositor') === -1
                })
                budget.products = productsRemove;
                budgets.push(budget)
            }
            const budgetsClon = _.cloneDeep(budgets)
            const budgetsOrder = _.orderBy(budgetsClon, 'id', 'desc')

            setBudgetsFinish(budgetsOrder.filter((budget)=>{
              return budget.brand != 'scheurich'
            }))
            setBudgetsScheurichFinish(budgetsOrder.filter((budget)=>{
              return budget.brand == 'scheurich'
            }))
            
        }).catch(err => {
            console.log('err', err)
        })
        
        getCartsUser(userData.id).then(res => {
            let productsRemove = [];
            let budgets = []
            for (let i = 0; i < res.data.length; i++) {
                const budget = res.data[i];
                const productsArray = JSON.parse(budget.products)
                productsRemove = _.remove(productsArray, product => {
                    return product.product.Nombre.toLowerCase().indexOf('expositor') === -1
                })
                budget.products = productsRemove;
                budgets.push(budget)
            }
            const budgetsClon = _.cloneDeep(budgets)
            const budgetsOrder = _.orderBy(budgetsClon, 'id', 'desc')

            setBudgetsSave(budgetsOrder.filter((budget)=>{
              return budget.brand != 'scheurich'
            }))
            setBudgetsScheurichSave(budgetsOrder.filter((budget)=>{
              return budget.brand == 'scheurich'
            }))
        }).catch(err => {
            console.log('err', err)
        })
    }, [])

    return (
        <div className="user-budgets-container">
            <UserBudgetsBlock title="Presupuestos guardados" budgets={budgetsSave} marca='fansa' textButtonAdd="Continuar presupuesto"></UserBudgetsBlock>
            <UserBudgetsBlock title="Presupuestos guardados" budgets={budgetsScheurichSave} marca='scheurich' textButtonAdd="Continuar presupuesto"></UserBudgetsBlock>
            
            <UserBudgetsBlock title="Presupuestos enviados" budgets={budgetsFinish} marca='fansa' textButtonAdd="Volver a presupuestar"></UserBudgetsBlock>
            <UserBudgetsBlock title="Presupuestos enviados" budgets={budgetsScheurichFinish} marca='scheurich' textButtonAdd="Volver a presupuestar"></UserBudgetsBlock>
        </div>
    )
}

export default UserBudgets
